// Données nécessaires pour démarrer l'app sans réseau, enregistrées à chaque démarrage en ligne
const BOOT_KEY = 'boot';

export const createBootCache = (db) => ({
    // Jamais attendu par App : un échec (base illisible, appareil plein) reste sans effet
    save: (partial) => db.transaction('rw', db.meta, async () => {
        const current = (await db.meta.get(BOOT_KEY))?.value || {};
        await db.meta.put({ key: BOOT_KEY, value: { ...current, ...partial, savedAt: new Date().toISOString() } });
    }).catch(console.error),
    load: async () => (await db.meta.get(BOOT_KEY))?.value || null
});
